module.exports = __webpack_public_path__ + "static/media/ironIcon.85c31f29.svg";